// DEV MOCK — dati finti usati solo quando backend-consumer (:3001) non
// risponde, così si può lavorare sulla UI senza avere Core/RabbitMQ avviati.
// Rimuovere questo blocco (e il suo uso in fetchJobs) quando il backend è
// sempre disponibile in locale.
//
// Campi come order_number, assigned_user, line_count e confidence NON fanno
// ancora parte del contratto reale di backend-consumer (vedi CLAUDE.md) —
// arriveranno da Queuer+Matcher. Sono qui solo per poter disegnare la
// tabella; quando il backend li esporrà davvero, mappare qui sotto invece
// di leggerli da MOCK_ORDERS.
//
// Condiviso tra le pagine Storico e Dashboard (overview), così i numeri
// mostrati restano coerenti tra le due viste finché usiamo dati finti.
export const MOCK_ORDERS = [
  {
    job_id: 'a1f2c9e0',
    status: 'completed', // → "Da revisionare"
    sender: 'acquisti@harborpoint.com',
    subject: '01_nostro_C00005_HARBOR.pdf',
    client_name: 'Harbor Point Construction Inc',
    client_matches: [
      { name: 'Harbor Point Construction Inc', code: 'HP-0042', confidence: 94 },
      { name: 'Harbor Point Logistics LLC', code: 'HL-0210', confidence: 58 },
      { name: 'Harborview Construction Co.', code: 'HV-0088', confidence: 51 },
    ],
    client_piva: 'US772113490',
    client_code: 'HP-0042',
    client_legal_address: 'Harbor Point Construction Inc — 450 Atlantic Ave, 02110 Boston, MA',
    client_note: '',
    order_number: 'HP-PO-77302',
    // destination = best match individuato dall'LLM (destinazione_match) tra
    // le sedi del cliente sotto: qui il cantiere, non la sede legale.
    destination: 'Cantiere Harbor Point — 450 Atlantic Ave, Boston, MA',
    destination_options: [
      { name: 'Jenia Ceramiche S.r.l. — Sede Legale, Via Grandi 12, Sassuolo (MO)', is_legal: true },
      { name: 'Magazzino Jenia Nord — Via dell\'Industria 8, Sassuolo (MO)', is_legal: false },
      { name: 'Cantiere Harbor Point — 450 Atlantic Ave, Boston, MA', is_legal: false },
    ],
    assigned_user: { name: 'Giulia Ferrari', initials: 'GF' },
    line_count: 10,
    confidence: 94,
    elapsed_seconds: 10.69,
    mock_pdf_url: '/mock-pdfs/01_nostro_C00005_HARBOR.pdf',
    body: 'HARBOR POINT CONSTRUCTION INC\n450 Atlantic Ave\n02110 Boston, MA\nP.IVA / VAT: US772113490\n\nORDINE DI ACQUISTO / PURCHASE ORDER\nN. Ordine: HP-PO-77302   Data: 13/04/2026\nPagamento: 30 gg f.m.   Consegna: entro 30 giorni\n\nDESTINATARIO: Jenia Ceramiche S.r.l.\n\n1. Soglia marmo composito bianco 60x15 spessore 2cm — PSSOGL60 — 40,7 N. — 42,42€ — 1726,49€ — 08/05/2026\n2. Adesivo cementizio rapido a presa accelerata 25kg — CLRAP25 — 19,5 N. — 24,09€ — 469,75€ — 06/06/2026\n3. Gres porcellanato effetto cemento Avorio 60x120 Lucido CEMENTO — CEAV60120LU — 95,3 MQ — 25,48€ — 2428,24€ — 03/06/2026\n4. Gradino costa retta MARMO LUX 33x120 — PSGDML — 47,8 N. — 49,33€ — 2357,97€ — 19/05/2026\n5. Listello decorato in ceramica 5x60 serie DECOR — PSLIS60 — 50,0 N. — 14,98€ — 749,00€ — 03/06/2026\n6. Battiscopa abbinato TERRA 7x30 — PSBTTR — 23,6 MT — 8,54€ — 201,54€ — 04/06/2026\n7. Bidet sospeso ceramica bianco lucido AURORA — SNBT01 — 10,0 N. — 146,59€ — 1465,90€ — 03/05/2026\n8. Distanziatori crociera 3mm sacchetto 250pz — DISCR3 — 40,1 N. — 4,32€ — 173,23€ — 10/06/2026\n9. Gres porcellanato effetto cemento Antracite 60x60 Lucido CEMENTO — CEAN6060LU — 163,2 MQ — 19,49€ — 3180,77€ — 09/06/2026\n10. Angolo esterno abbinato MARMO LUX rettificato — PSANG01 — 11,7 N. — 21,02€ — 245,93€ — 01/06/2026',
    lines: [
      { description: 'Soglia marmo composito bianco 60x15 spessore 2cm', raw_text: 'Soglia marmo composito bianco 60x15 spessore 2cm', matched_article: 'PSSOGL60', qty: '40,7', um: 'N.', delivery: '2026-05-08' },
      { description: 'Adesivo cementizio rapido a presa accelerata 25kg', raw_text: 'Adesivo cementizio rapido a presa accelerata 25kg', matched_article: 'CLRAP25', qty: '19,5', um: 'N.', delivery: '2026-06-06' },
      { description: 'Gres porcellanato effetto cemento Avorio 60x120 Lucido CEMENTO', raw_text: 'Gres porcellanato effetto cemento Avorio 60x120 Lucido CEMENTO', matched_article: 'CEAV60120LU', qty: '95,3', um: 'MQ', delivery: '2026-06-03' },
      { description: 'Gradino costa retta MARMO LUX 33x120', raw_text: 'Gradino costa retta MARMO LUX 33x120', matched_article: 'PSGDML', qty: '47,8', um: 'N.', delivery: '2026-05-19' },
      { description: 'Listello decorato in ceramica 5x60 serie DECOR', raw_text: 'Listello decorato in ceramica 5x60 serie DECOR', matched_article: 'PSLIS60', qty: '50,0', um: 'N.', delivery: '2026-06-03' },
      { description: 'Battiscopa abbinato TERRA 7x30', raw_text: 'Battiscopa abbinato TERRA 7x30', matched_article: 'PSBTTR', qty: '23,6', um: 'MT', delivery: '2026-06-04' },
      { description: 'Bidet sospeso ceramica bianco lucido AURORA', raw_text: 'Bidet sospeso ceramica bianco lucido AURORA', matched_article: 'SNBT01', qty: '10,0', um: 'N.', delivery: '2026-05-03' },
      { description: 'Distanziatori crociera 3mm sacchetto 250pz', raw_text: 'Distanziatori crociera 3mm sacchetto 250pz', matched_article: 'DISCR3', qty: '40,1', um: 'N.', delivery: '2026-06-10' },
      { description: 'Gres porcellanato effetto cemento Antracite 60x60 Lucido CEMENTO', raw_text: 'Gres porcellanato effetto cemento Antracite 60x60 Lucido CEMENTO', matched_article: 'CEAN6060LU', qty: '163,2', um: 'MQ', delivery: '2026-06-09' },
      { description: 'Angolo esterno abbinato MARMO LUX rettificato', raw_text: 'Angolo esterno abbinato MARMO LUX rettificato', matched_article: 'PSANG01', qty: '11,7', um: 'N.', delivery: '2026-06-01' },
    ],
    matched_record: { matched_id: 'WDG-114', matched_product: 'Faldoni ufficio A4, confezione da 25', matched_quantity: 120 },
    match_result: null,
    attachments: [],
    timestamp: new Date('2026-04-13T09:14:00').toISOString(),
  },
  {
    job_id: 'b7c3d1a4',
    status: 'approved',
    sender: 'ordini@edilbianchi.it',
    subject: 'Re: conferma fornitura settimana 31',
    client_name: 'Edil Bianchi S.r.l.',
    client_matches: [
      { name: 'Edil Bianchi S.r.l.', code: 'ED-0091', confidence: 71 },
      { name: 'Edil Bianchi Group S.r.l.', code: 'EB-0134', confidence: 64 },
      { name: 'Bianchi Costruzioni S.r.l.', code: 'BC-0067', confidence: 47 },
    ],
    client_piva: 'IT01234560123',
    client_code: 'ED-0091',
    client_legal_address: 'Edil Bianchi S.r.l. — Via Roma 45, 41100 Modena (MO)',
    client_note: '',
    order_number: 'ORD-2026-0416',
    assigned_user: { name: 'Marco Neri', initials: 'MN' },
    line_count: 1,
    confidence: 71,
    elapsed_seconds: 8.9,
    body: 'Confermiamo la fornitura per la settimana 31 come da accordi.',
    lines: [
      { description: 'Connettori RJ45 cat.6, confezione 500pz', raw_text: 'Connettori RJ45 cat.6, confezione 500pz', matched_article: 'ELX-8842', match_options: ['ELX-8842', 'ELX-8850', 'ELX-9010'], qty: '500', um: 'PZ', delivery: '2026-08-04' },
    ],
    matched_record: { matched_id: 'ELX-8842', matched_product: 'Connettori RJ45 cat.6', matched_quantity: 500 },
    match_result: null,
    attachments: [],
    timestamp: new Date('2026-07-29T08:47:00').toISOString(),
  },
  {
    job_id: 'd4e8f620',
    status: 'rejected',
    sender: 'segreteria@marmigalli.it',
    subject: 'Ordine campionatura agosto',
    client_name: 'Marmi Galli S.n.c.',
    client_matches: [
      { name: 'Marmi Galli S.n.c.', code: 'MG-0187', confidence: 88 },
      { name: 'Galli Marmi e Graniti S.r.l.', code: 'GM-0295', confidence: 55 },
      { name: 'Marmi Galletti S.r.l.', code: 'ML-0113', confidence: 42 },
    ],
    client_piva: 'IT09876540123',
    client_code: 'MG-0187',
    client_legal_address: 'Marmi Galli S.n.c. — Via delle Cave 12, 54100 Massa (MS)',
    client_note: '',
    order_number: 'ORD-2026-0415',
    // Richiesta di campionatura: l'LLM la classifica come offerta, non ordine.
    order_type: 'offerta',
    assigned_user: { name: 'Giulia Ferrari', initials: 'GF' },
    line_count: 2,
    confidence: 88,
    elapsed_seconds: 10.2,
    body: 'Richiesta campionatura per il mese di agosto.',
    lines: [
      { description: 'Piastrella campione 30x30 grigio', raw_text: 'Piastrella campione 30x30 grigio', matched_article: null, qty: '20', um: 'MQ', delivery: '2026-08-10' },
      { description: 'Adesivo campione uso interno', raw_text: 'Adesivo campione uso interno', matched_article: null, qty: '5', um: 'KG', delivery: '2026-08-10' },
    ],
    matched_record: null,
    match_result: null,
    attachments: [],
    timestamp: new Date('2026-07-28T18:31:00').toISOString(),
  },
  {
    job_id: 'c9d1b845',
    status: 'completed', // → "Da revisionare" (confidenza bassa, va controllato a mano)
    sender: 'info@ferramentaverdi.it',
    subject: 'ORDINE_4482.pdf',
    client_name: 'Ferramenta Verdi',
    client_matches: [
      { name: 'Ferramenta Verdi', confidence: 18 },
      { name: 'Verdi Utensileria S.r.l.', confidence: 15 },
      { name: 'Ferramenta Verdi Nord', confidence: 11 },
    ],
    client_piva: null,
    client_code: null,
    client_note: '',
    order_number: 'ORD-2026-0414',
    assigned_user: null,
    line_count: 0,
    confidence: 18,
    elapsed_seconds: 21.7,
    // Errore di sistema (non "nessun match trovato" per un singolo campo,
    // ma il matching nel suo complesso andato in errore lato Queuer) — banner
    // rosso sopra "Recap. ordine" in OrderReview.jsx. `code` è il codice
    // errore che passerà il backend; qui è finto finché non esiste un vero
    // campo dedicato (vedi CLAUDE.md).
    system_error: {
      code: 'MATCH_LOW_CONFIDENCE',
      message: 'Il matching cliente non ha raggiunto una confidenza sufficiente (18%): verificare manualmente prima di approvare.',
    },
    body: 'Documento di difficile lettura: pochi campi estratti con affidabilità, richiede verifica manuale.',
    lines: [],
    matched_record: null,
    match_result: null,
    attachments: [],
    timestamp: new Date('2026-07-28T17:02:00').toISOString(),
  },
  {
    // Test con documento reale caricato dall'utente: non è una mail
    // d'ordine ma un computo metrico (fabbisogno impianto antincendio).
    // Nessun mittente/cliente/numero ordine riconoscibile nel testo: buon
    // caso limite per verificare come si comporta la UI quando il
    // documento non è nel formato atteso.
    job_id: 'f3a91b2e',
    status: 'completed',
    sender: null,
    subject: 'FABBISOGNO ANTINCENDIO.pdf',
    client_name: null,
    client_matches: [], // nessun cliente riconoscibile nel testo: nessuna alternativa da proporre
    client_piva: null,
    client_code: null,
    client_note: '',
    order_number: null,
    assigned_user: null,
    line_count: 13,
    confidence: 41,
    elapsed_seconds: 18.3,
    mock_pdf_url: '/mock-pdfs/FABBISOGNO_ANTINCENDIO.pdf',
    body: 'Computo metrico — Fabbisogno impianto antincendio\n\nDocumento tecnico (elenco voci con quantità), non una mail d\'ordine: nessun mittente, cliente o numero ordine riconoscibile nel testo.\n\n1. Attacco motopompa UNI 70 (gruppo completo) — 2,00 cad\n2. Idrante a colonna soprassuolo UNI 70 — 127,00 cad\n3. Cassetta per idrante da esterno UNI 70, acciaio inox — 127,00 cad\n4. Cassetta per idrante da esterno UNI 45, lamiera verniciata rossa — 9,00 cad\n5. Saracinesca in ghisa DN 50 (2") — 12,00 cad\n6. Saracinesca in ghisa DN 65 (2"1/2) — 106,00 cad\n7. Saracinesca in ghisa DN 80 (3") — 62,00 cad\n8. Saracinesca in ghisa DN 200 (8") — 6,00 cad\n9. Saracinesca in ghisa DN 300 (12") — 5,00 cad\n10. Valvola di ritegno a molla DN 80 (3") — 1,00 cad\n11. Riduttore di pressione DN 80 (3"), Q=35 — 1,00 cad\n12. Gruppo antincendio di pressurizzazione UNI EN 12845 — 1,00 cad\n13. Serbatoio a pressione atmosferica in vetroresina, C=10000L — 2,00 cad',
    lines: [
      { description: 'Attacco motopompa UNI 70 (gruppo completo)', raw_text: 'Attacco motopompa UNI 70 (gruppo completo)', matched_article: null, qty: '2,00', um: 'PZ', delivery: '' },
      { description: 'Idrante a colonna soprassuolo UNI 70', raw_text: 'Idrante a colonna soprassuolo UNI 70', matched_article: null, qty: '127,00', um: 'PZ', delivery: '' },
      { description: 'Cassetta per idrante da esterno UNI 70, acciaio inox', raw_text: 'Cassetta per idrante da esterno UNI 70, acciaio inox', matched_article: null, qty: '127,00', um: 'PZ', delivery: '' },
      { description: 'Cassetta per idrante da esterno UNI 45, lamiera verniciata rossa', raw_text: 'Cassetta per idrante da esterno UNI 45, lamiera verniciata rossa', matched_article: null, qty: '9,00', um: 'PZ', delivery: '' },
      { description: 'Saracinesca in ghisa DN 50 (2")', raw_text: 'Saracinesca in ghisa DN 50 (2")', matched_article: null, qty: '12,00', um: 'PZ', delivery: '' },
      { description: 'Saracinesca in ghisa DN 65 (2"1/2)', raw_text: 'Saracinesca in ghisa DN 65 (2"1/2)', matched_article: null, qty: '106,00', um: 'PZ', delivery: '' },
      { description: 'Saracinesca in ghisa DN 80 (3")', raw_text: 'Saracinesca in ghisa DN 80 (3")', matched_article: null, qty: '62,00', um: 'PZ', delivery: '' },
      { description: 'Saracinesca in ghisa DN 200 (8")', raw_text: 'Saracinesca in ghisa DN 200 (8")', matched_article: null, qty: '6,00', um: 'PZ', delivery: '' },
      { description: 'Saracinesca in ghisa DN 300 (12")', raw_text: 'Saracinesca in ghisa DN 300 (12")', matched_article: null, qty: '5,00', um: 'PZ', delivery: '' },
      { description: 'Valvola di ritegno a molla DN 80 (3")', raw_text: 'Valvola di ritegno a molla DN 80 (3")', matched_article: null, qty: '1,00', um: 'PZ', delivery: '' },
      { description: 'Riduttore di pressione DN 80 (3"), Q=35', raw_text: 'Riduttore di pressione DN 80 (3"), Q=35', matched_article: null, qty: '1,00', um: 'PZ', delivery: '' },
      { description: 'Gruppo antincendio di pressurizzazione UNI EN 12845', raw_text: 'Gruppo antincendio di pressurizzazione UNI EN 12845', matched_article: null, qty: '1,00', um: 'PZ', delivery: '' },
      { description: 'Serbatoio a pressione atmosferica in vetroresina, C=10000L', raw_text: 'Serbatoio a pressione atmosferica in vetroresina, C=10000L', matched_article: null, qty: '2,00', um: 'PZ', delivery: '' },
    ],
    matched_record: null,
    match_result: null,
    attachments: [],
    timestamp: new Date('2026-07-29T17:05:00').toISOString(),
  },
  {
    // Test con allegato Excel/CSV: il Core converte il foglio in testo con
    // una tabella in stile markdown (pipe + riga di separatore). Buon caso
    // per verificare che PdfViewer la renderizzi come tabella vera invece
    // che come testo grezzo, mantenendo il corpo della mail leggibile sopra.
    job_id: 'e2b7c410',
    status: 'completed',
    sender: 'ordini@ceramichebianchi.it',
    subject: 'Foglio_Ordine_Settimanale.xlsx',
    client_name: 'Ceramiche Bianchi S.p.A.',
    client_matches: [
      { name: 'Ceramiche Bianchi S.p.A.', code: 'CB-0356', confidence: 76 },
      { name: 'Bianchi Ceramiche Group', code: 'BG-0271', confidence: 49 },
      { name: 'Ceramiche Bianchi Nord S.r.l.', code: 'CN-0198', confidence: 38 },
    ],
    client_piva: 'IT03344550124',
    client_code: 'CB-0356',
    client_legal_address: 'Ceramiche Bianchi S.p.A. — Via Industriale 45, 41049 Sassuolo (MO)',
    client_note: '',
    order_number: 'CB-2026-0731',
    // Nessun match di destinazione dall'LLM in questo caso: la UI deve
    // ricadere sulla sede legale del cliente tra quelle sotto.
    destination: null,
    destination_options: [
      { name: 'Ceramiche Bianchi S.p.A. — Sede Legale, Via Industriale 45, Sassuolo (MO)', is_legal: true },
      { name: 'Magazzino Bianchi Est — Via Verdi 3, Modena (MO)', is_legal: false },
    ],
    assigned_user: { name: 'Marco Neri', initials: 'MN' },
    line_count: 6,
    confidence: 76,
    elapsed_seconds: 14.1,
    body: 'Buongiorno,\n\ninviamo in allegato il foglio ordine della settimana, generato da Excel — di seguito la tabella estratta dal documento:\n\n| Codice | Descrizione | Qtà | UM | Prezzo € |\n|---|---|---|---|---|\n| CB-1042 | Gres porc. Bianco Puro 60x60 | 120 | MQ | 22,50 |\n| CB-1088 | Battiscopa abbinato 7x60 | 45 | MT | 6,80 |\n| CB-2210 | Adesivo cementizio standard 25kg | 30 | N. | 11,20 |\n| CB-3305 | Fuga cementizia bianca 5kg | 18 | N. | 7,40 |\n| CB-4021 | Profilo alluminio a L 2,7m | 20 | N. | 9,90 |\n| CB-5560 | Distanziatori 2mm sacchetto 200pz | 12 | CF | 3,15 |\n\nRestiamo a disposizione per eventuali chiarimenti.\n\nCordiali saluti,\nUfficio Acquisti Ceramiche Bianchi',
    lines: [
      {
        // raw_text abbreviato ("porc." invece di "porcellanato") apposta,
        // per mostrare un caso in cui il testo letto dal documento non è
        // identico al titolo scelto dal match (qui il best match a 91%) —
        // vedi raw_text vs description in OrderReview.jsx.
        description: 'Gres porcellanato Bianco Puro 60x60', raw_text: 'Gres porc. Bianco Puro 60x60', matched_article: 'CB-1042', qty: '120', um: 'MQ', delivery: '',
        description_matches: [
          { name: 'Gres porcellanato Bianco Puro 60x60', confidence: 91 },
          { name: 'Gres porcellanato Bianco Assoluto 60x60', confidence: 54 },
          { name: 'Gres porcellanato Bianco Puro 60x120', confidence: 47 },
        ],
      },
      {
        description: 'Battiscopa abbinato 7x60', raw_text: 'Battiscopa abbinato 7x60', matched_article: 'CB-1088', qty: '45', um: 'MT', delivery: '',
        description_matches: [
          { name: 'Battiscopa abbinato 7x60', confidence: 88 },
          { name: 'Battiscopa abbinato 8x60', confidence: 45 },
        ],
      },
      {
        description: 'Adesivo cementizio standard 25kg', raw_text: 'Adesivo cementizio standard 25kg', matched_article: 'CB-2210', qty: '30', um: 'N.', delivery: '',
        description_matches: [
          { name: 'Adesivo cementizio standard 25kg', confidence: 82 },
          { name: 'Adesivo cementizio rinforzato 25kg', confidence: 41 },
        ],
      },
      { description: 'Fuga cementizia bianca 5kg', raw_text: 'Fuga cementizia bianca 5kg', matched_article: 'CB-3305', qty: '18', um: 'N.', delivery: '' },
      { description: 'Profilo alluminio a L 2,7m', raw_text: 'Profilo alluminio a L 2,7m', matched_article: 'CB-4021', qty: '20', um: 'N.', delivery: '' },
      { description: 'Distanziatori 2mm sacchetto 200pz', raw_text: 'Distanziatori 2mm sacchetto 200pz', matched_article: 'CB-5560', qty: '12', um: 'CF', delivery: '' },
    ],
    matched_record: null,
    match_result: null,
    attachments: [],
    timestamp: new Date('2026-07-31T09:20:00').toISOString(),
  },
  {
    // Test scorrimento dinamico su PDF vero e lungo (33 pagine, computo
    // metrico impianti meccanici) — caricato dall'utente apposta per
    // verificare la fase 2 (ricerca nel layer testo di pdf.js + scroll
    // automatico + evidenziazione, vedi PdfViewer.jsx/findTextMatch). Non è
    // una mail d'ordine: come FABBISOGNO_ANTINCENDIO, nessun mittente/
    // cliente riconoscibile. Le "righe" qui sotto sono titoli di capitolo
    // presi verbatim da pagine diverse e distanti del documento (pag. 1, 6,
    // 11, 16, 21, 26, 33) proprio per testare che lo scroll dinamico
    // raggiunga correttamente pagine sparse in un PDF molto lungo, non solo
    // la prima.
    job_id: 'g6h2k901',
    status: 'completed',
    sender: null,
    subject: '25027_MXE_CM01R00.pdf',
    client_name: null,
    client_matches: [],
    client_piva: null,
    client_code: null,
    client_note: '',
    order_number: null,
    assigned_user: null,
    line_count: 7,
    confidence: 35,
    elapsed_seconds: 24.6,
    mock_pdf_url: '/mock-pdfs/25027_MXE_CM01R00.pdf',
    body: 'Computo metrico impianti meccanici — PROGETTO ESECUTIVO FABBRICATO AD USO COMMERCIALE, Via Lucchese 45, Montecatini Terme (Esselunga S.p.A.). Documento tecnico di 33 pagine, non una mail d\'ordine: nessun mittente, cliente o numero ordine riconoscibile nel testo.',
    lines: [
      { description: 'FABBRICATO AD USO COMMERCIALE', raw_text: 'FABBRICATO AD USO COMMERCIALE', matched_article: null, qty: '1', um: 'PZ', delivery: '' },
      { description: 'IMPIANTO DI CONDIZIONAMENTO SALA VENDITA', raw_text: 'IMPIANTO DI CONDIZIONAMENTO SALA VENDITA', matched_article: null, qty: '1', um: 'N.', delivery: '' },
      { description: 'IMPIANTO DI CONDIZIONAMENTO BAR', raw_text: 'IMPIANTO DI CONDIZIONAMENTO BAR', matched_article: null, qty: '1', um: 'N.', delivery: '' },
      { description: 'IMPIANTO DI ESTRAZIONE ARIA LOCALI TECNICI', raw_text: 'IMPIANTO DI ESTRAZIONE ARIA LOCALI TECNICI', matched_article: null, qty: '1', um: 'N.', delivery: '' },
      { description: 'RETI GENERALI DI DISTRIBUZIONE IDRICA', raw_text: 'RETI GENERALI DI DISTRIBUZIONE IDRICA', matched_article: null, qty: '1', um: 'MT', delivery: '' },
      { description: 'SANIFICAZIONE CIRCUITI SANITARI E RIPRISTINO CIRCUITI CHIUSI', raw_text: 'SANIFICAZIONE CIRCUITI SANITARI E RIPRISTINO CIRCUITI CHIUSI', matched_article: null, qty: '1', um: 'CF', delivery: '' },
      { description: 'RIEPILOGO GENERALE', raw_text: 'RIEPILOGO GENERALE', matched_article: null, qty: '1', um: 'PZ', delivery: '' },
    ],
    matched_record: null,
    match_result: null,
    attachments: [],
    timestamp: new Date('2026-07-31T11:40:00').toISOString(),
  },
]

// Solo tre stati reali per un ordine: in attesa di revisione, approvato o
// rifiutato dal commerciale. Non esiste uno stato di errore a sé — un
// documento poco leggibile resta comunque "Da revisionare" (con confidenza
// bassa) finché qualcuno non lo controlla a mano.
export const STATUS_META = {
  completed: { label: 'Da revisionare', color: 'var(--warn)', bg: 'var(--warn-soft-bg)', border: 'var(--warn-border)' },
  approved: { label: 'Approvato', color: 'var(--ok)', bg: 'var(--ok-soft-bg)', border: 'var(--ok-border)' },
  rejected: { label: 'Rifiutato', color: 'var(--danger)', bg: 'var(--danger-soft-bg)', border: 'var(--danger-border)' },
}

// Ordine di visualizzazione in Storico: prima gli ordini da revisionare
// (serve intervenire), poi approvati e rifiutati in fondo (già decisi).
// A parità di rango, il più recente prima (vedi sort in Dashboard.jsx).
export const STATUS_SORT_RANK = {
  completed: 0,
  approved: 1,
  rejected: 1,
}

export const FILTER_TABS = [
  { key: 'all', label: 'Tutti' },
  { key: 'approved', label: 'Approvati' },
  { key: 'completed', label: 'In revisione' },
  { key: 'rejected', label: 'Rifiutati' },
]

export function formatDateTime(iso) {
  if (!iso) return '—'
  const d = new Date(iso)
  const date = d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: '2-digit' })
  const time = d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })
  return `${date}, ${time}`
}

export function confidenceColor(pct) {
  if (pct == null) return 'var(--text-3)'
  if (pct >= 80) return 'var(--ok)'
  if (pct >= 50) return 'var(--warn)'
  return 'var(--danger)'
}

// Origine dell'ordine: se c'è un mittente con una vera email è arrivato via
// mail (con o senza allegato), altrimenti è un documento caricato a mano
// (vedi NewOrderModal / handleCreateManualOrder, dove il sender è null o
// "Caricamento manuale"). Euristica semplice basata sui dati che abbiamo
// oggi — se in futuro arriva un campo esplicito tipo `source` dal backend,
// sostituire questa funzione con quello.
export function orderOrigin(order) {
  if (order?.sender && order.sender.includes('@')) return 'mail'
  return 'document'
}

// DEV MOCK — mail/ordini arrivati su ai@jenia.ai e ancora "in coda": o
// stanno attraversando la pipeline (status 'processing') oppure sono già
// stati estratti e aspettano solo la revisione umana (status 'ready').
// Ogni voce 'ready' porta con sé dati completi (cliente/ordine/righe) nello
// stesso formato di MOCK_ORDERS, così può essere aperta nella stessa vista
// di revisione (OrderReview) usata da Storico.
// TODO: quando approvato/rifiutato da qui, l'ordine oggi sparisce solo dalla
// coda lato client — andrà invece inviato al backend e fatto comparire in
// Storico tramite una vera chiamata API.
export const MOCK_QUEUE = [
  {
    job_id: 'q-9284',
    status: 'ready', // 'ready' → pronto per revisione, 'processing' → ancora in pipeline
    sender_name: 'Hassan Karim',
    sender: 'h.karim@atlassurfaces.com',
    subject: 'Ordine Atlas Tile — settimana 22',
    thread: null,
    forwarded_at: new Date(Date.now() - 10 * 60 * 1000).toISOString(),
    processed_at: new Date(Date.now() - 3 * 60 * 1000).toISOString(),
    avatar_color: '#5B4FCF',
    client_name: 'Atlas Tile Co.',
    client_matches: [
      { name: 'Atlas Tile Co.', code: 'AT-0918', confidence: 82 },
      { name: 'Atlas Surfaces LLC', code: 'AS-0733', confidence: 57 },
      { name: 'Atlas Building Supply', code: 'AB-0561', confidence: 44 },
    ],
    client_piva: 'US441209875',
    client_code: 'AT-0918',
    client_legal_address: 'Atlas Tile Co. — 1180 Industrial Pkwy, Denver, CO',
    client_note: '',
    order_number: 'AT-2026-0522',
    destination: null,
    body: 'ATLAS TILE CO.\n1180 Industrial Pkwy\nDenver, CO\n\nOrdine settimana 22 — confermiamo quanto discusso.\n\n1. Gres porcellanato Terra Bianco 60x60 — 180 MQ — consegna 12/06/2026\n2. Gres porcellanato Terra Grigio 60x60 — 140 MQ — consegna 12/06/2026\n3. Battiscopa abbinato Terra 7x60 — 90 MT — consegna 12/06/2026\n4. Adesivo cementizio rinforzato 25kg — 30 N. — consegna 05/06/2026\n5. Fuga epossidica grigio cemento 5kg — 18 N. — consegna 05/06/2026\n6. Profilo alluminio terminale 2,5m — 40 N. — consegna 12/06/2026\n7. Gradino costa retta Terra 33x120 — 22 N. — consegna 15/06/2026\n8. Distanziatori crociera 2mm — 15 CF — consegna 05/06/2026\n9. Rete portaintonaco per posa — 60 MQ — consegna 08/06/2026\n10. Primer aggrappante universale 5L — 12 N. — consegna 05/06/2026',
    lines: [
      { description: 'Gres porcellanato Terra Bianco 60x60', raw_text: 'Gres porcellanato Terra Bianco 60x60', matched_article: 'TRBI6060', qty: '180', um: 'MQ', delivery: '2026-06-12' },
      { description: 'Gres porcellanato Terra Grigio 60x60', raw_text: 'Gres porcellanato Terra Grigio 60x60', matched_article: 'TRGR6060', qty: '140', um: 'MQ', delivery: '2026-06-12' },
      { description: 'Battiscopa abbinato Terra 7x60', raw_text: 'Battiscopa abbinato Terra 7x60', matched_article: 'BTTR760', qty: '90', um: 'MT', delivery: '2026-06-12' },
      { description: 'Adesivo cementizio rinforzato 25kg', raw_text: 'Adesivo cementizio rinforzato 25kg', matched_article: 'CLRIN25', qty: '30', um: 'N.', delivery: '2026-06-05' },
      { description: 'Fuga epossidica grigio cemento 5kg', raw_text: 'Fuga epossidica grigio cemento 5kg', matched_article: 'FGEP05', qty: '18', um: 'N.', delivery: '2026-06-05' },
      { description: 'Profilo alluminio terminale 2,5m', raw_text: 'Profilo alluminio terminale 2,5m', matched_article: 'PRALT25', qty: '40', um: 'N.', delivery: '2026-06-12' },
      { description: 'Gradino costa retta Terra 33x120', raw_text: 'Gradino costa retta Terra 33x120', matched_article: 'GDTR33120', qty: '22', um: 'N.', delivery: '2026-06-15' },
      { description: 'Distanziatori crociera 2mm', raw_text: 'Distanziatori crociera 2mm', matched_article: 'DISCR2', qty: '15', um: 'CF', delivery: '2026-06-05' },
      { description: 'Rete portaintonaco per posa', raw_text: 'Rete portaintonaco per posa', matched_article: 'RTPI01', qty: '60', um: 'MQ', delivery: '2026-06-08' },
      { description: 'Primer aggrappante universale 5L', raw_text: 'Primer aggrappante universale 5L', matched_article: 'PRAGG05', qty: '12', um: 'N.', delivery: '2026-06-05' },
    ],
  },
  {
    job_id: 'q-9285',
    status: 'ready',
    sender_name: 'Astrid Lindgren',
    sender: 'astrid@nordicstonetile.com',
    subject: 'Nordic Stone — preparazione ordine showroom Oslo',
    thread: { count: 3 },
    forwarded_at: new Date(Date.now() - 11 * 60 * 1000).toISOString(),
    processed_at: new Date(Date.now() - 4 * 60 * 1000).toISOString(),
    avatar_color: '#2E7D6B',
    client_name: 'Nordic Stone Tile AB',
    client_matches: [
      { name: 'Nordic Stone Tile AB', code: 'NS-0442', confidence: 79 },
      { name: 'Nordic Stone Group AB', code: 'NG-0329', confidence: 60 },
      { name: 'Nordic Tile & Stone', code: 'NT-0154', confidence: 41 },
    ],
    client_piva: 'SE556677889901',
    client_code: 'NS-0442',
    client_legal_address: 'Nordic Stone Tile AB — Kungsgatan 22, Stoccolma',
    client_note: '',
    order_number: 'NS-OSLO-0142',
    destination: 'Showroom Oslo — Karl Johans gate 15, Oslo',
    destination_options: [
      { name: 'Nordic Stone Tile AB — Sede Legale, Kungsgatan 22, Stoccolma', is_legal: true },
      { name: 'Showroom Oslo — Karl Johans gate 15, Oslo', is_legal: false },
    ],
    body: 'NORDIC STONE TILE AB\nKungsgatan 22, Stoccolma\n\nOrdine per l\'allestimento dello showroom di Oslo, come discusso nel thread.\n\n1. Marmo Calacatta lastra 320x160 — 6 N. — consegna 20/06/2026\n2. Marmo Nero Marquina 60x60 lucido — 45 MQ — consegna 18/06/2026\n3. Basalto grigio spazzolato 40x40 — 60 MQ — consegna 18/06/2026\n4. Zoccolino marmo Calacatta 10x60 — 35 MT — consegna 20/06/2026\n5. Colla epossidica bicomponente 10kg — 8 N. — consegna 15/06/2026\n6. Ventose per movimentazione lastre — 4 N. — consegna 15/06/2026\n7. Sigillante neutro trasparente 290ml — 24 N. — consegna 15/06/2026\n8. Profilo a scomparsa acciaio inox — 30 MT — consegna 20/06/2026\n9. Pannello isolante sottopavimento — 60 MQ — consegna 16/06/2026\n10. Kit lucidatura marmo professionale — 2 N. — consegna 22/06/2026',
    lines: [
      { description: 'Marmo Calacatta lastra 320x160', raw_text: 'Marmo Calacatta lastra 320x160', matched_article: 'MCCL320160', qty: '6', um: 'N.', delivery: '2026-06-20' },
      { description: 'Marmo Nero Marquina 60x60 lucido', raw_text: 'Marmo Nero Marquina 60x60 lucido', matched_article: 'MNMQ6060', qty: '45', um: 'MQ', delivery: '2026-06-18' },
      { description: 'Basalto grigio spazzolato 40x40', raw_text: 'Basalto grigio spazzolato 40x40', matched_article: 'BSGR4040', qty: '60', um: 'MQ', delivery: '2026-06-18' },
      { description: 'Zoccolino marmo Calacatta 10x60', raw_text: 'Zoccolino marmo Calacatta 10x60', matched_article: 'ZCCL1060', qty: '35', um: 'MT', delivery: '2026-06-20' },
      { description: 'Colla epossidica bicomponente 10kg', raw_text: 'Colla epossidica bicomponente 10kg', matched_article: 'CLEP10', qty: '8', um: 'N.', delivery: '2026-06-15' },
      { description: 'Ventose per movimentazione lastre', raw_text: 'Ventose per movimentazione lastre', matched_article: 'VNTS01', qty: '4', um: 'N.', delivery: '2026-06-15' },
      { description: 'Sigillante neutro trasparente 290ml', raw_text: 'Sigillante neutro trasparente 290ml', matched_article: 'SGNT290', qty: '24', um: 'N.', delivery: '2026-06-15' },
      { description: 'Profilo a scomparsa acciaio inox', raw_text: 'Profilo a scomparsa acciaio inox', matched_article: 'PRSC-INOX', qty: '30', um: 'MT', delivery: '2026-06-20' },
      { description: 'Pannello isolante sottopavimento', raw_text: 'Pannello isolante sottopavimento', matched_article: 'PNIS01', qty: '60', um: 'MQ', delivery: '2026-06-16' },
      { description: 'Kit lucidatura marmo professionale', raw_text: 'Kit lucidatura marmo professionale', matched_article: 'KTLM-PRO', qty: '2', um: 'N.', delivery: '2026-06-22' },
    ],
  },
  {
    job_id: 'q-9286',
    status: 'ready',
    sender_name: 'Marcus Vance',
    sender: 'm.vance@harborpointconstruction.com',
    subject: 'URGENTE — Ordine Harbor Point fase 2',
    thread: null,
    forwarded_at: new Date(Date.now() - 11 * 60 * 1000).toISOString(),
    processed_at: new Date(Date.now() - 2 * 60 * 1000).toISOString(),
    avatar_color: '#A8792E',
    client_name: 'Harbor Point Construction Inc',
    client_matches: [
      { name: 'Harbor Point Construction Inc', code: 'HP-0042', confidence: 91 },
      { name: 'Harbor Point Logistics LLC', code: 'HL-0210', confidence: 55 },
      { name: 'Harborview Construction Co.', code: 'HV-0088', confidence: 48 },
    ],
    client_piva: 'US772113490',
    client_code: 'HP-0042',
    client_legal_address: 'Harbor Point Construction Inc — 450 Atlantic Ave, 02110 Boston, MA',
    client_note: '',
    order_number: 'HP-PO-77410',
    destination: 'Jenia Ceramiche S.r.l.',
    body: 'HARBOR POINT CONSTRUCTION INC\n450 Atlantic Ave, Boston, MA\n\nFase 2 del cantiere — procedere con urgenza.\n\n1. Gres porcellanato effetto cemento Avorio 60x120 — 70 MQ — consegna 10/06/2026\n2. Soglia marmo composito bianco 60x15 — 25 N. — consegna 10/06/2026\n3. Adesivo cementizio rapido 25kg — 15 N. — consegna 06/06/2026\n4. Listello decorato ceramica 5x60 — 30 N. — consegna 10/06/2026\n5. Battiscopa abbinato Terra 7x30 — 18 MT — consegna 10/06/2026\n6. Bidet sospeso ceramica bianco lucido — 6 N. — consegna 12/06/2026\n7. Distanziatori crociera 3mm — 20 N. — consegna 06/06/2026\n8. Angolo esterno abbinato Marmo Lux — 8 N. — consegna 10/06/2026\n9. Gradino costa retta Marmo Lux 33x120 — 14 N. — consegna 12/06/2026\n10. Fuga cementizia grigio scuro 5kg — 10 N. — consegna 06/06/2026',
    lines: [
      { description: 'Gres porcellanato effetto cemento Avorio 60x120', raw_text: 'Gres porcellanato effetto cemento Avorio 60x120', matched_article: 'CEAV60120LU', qty: '70', um: 'MQ', delivery: '2026-06-10' },
      { description: 'Soglia marmo composito bianco 60x15', raw_text: 'Soglia marmo composito bianco 60x15', matched_article: 'PSSOGL60', qty: '25', um: 'N.', delivery: '2026-06-10' },
      { description: 'Adesivo cementizio rapido 25kg', raw_text: 'Adesivo cementizio rapido 25kg', matched_article: 'CLRAP25', qty: '15', um: 'N.', delivery: '2026-06-06' },
      { description: 'Listello decorato ceramica 5x60', raw_text: 'Listello decorato ceramica 5x60', matched_article: 'PSLIS60', qty: '30', um: 'N.', delivery: '2026-06-10' },
      { description: 'Battiscopa abbinato Terra 7x30', raw_text: 'Battiscopa abbinato Terra 7x30', matched_article: 'PSBTTR', qty: '18', um: 'MT', delivery: '2026-06-10' },
      { description: 'Bidet sospeso ceramica bianco lucido', raw_text: 'Bidet sospeso ceramica bianco lucido', matched_article: 'SNBT01', qty: '6', um: 'N.', delivery: '2026-06-12' },
      { description: 'Distanziatori crociera 3mm', raw_text: 'Distanziatori crociera 3mm', matched_article: 'DISCR3', qty: '20', um: 'N.', delivery: '2026-06-06' },
      { description: 'Angolo esterno abbinato Marmo Lux', raw_text: 'Angolo esterno abbinato Marmo Lux', matched_article: 'PSANG01', qty: '8', um: 'N.', delivery: '2026-06-10' },
      { description: 'Gradino costa retta Marmo Lux 33x120', raw_text: 'Gradino costa retta Marmo Lux 33x120', matched_article: 'PSGDML', qty: '14', um: 'N.', delivery: '2026-06-12' },
      { description: 'Fuga cementizia grigio scuro 5kg', raw_text: 'Fuga cementizia grigio scuro 5kg', matched_article: 'FGCM05', qty: '10', um: 'N.', delivery: '2026-06-06' },
    ],
  },
]

export function formatMinutesAgo(iso) {
  if (!iso) return '—'
  const diffMs = Date.now() - new Date(iso).getTime()
  const minutes = Math.max(0, Math.round(diffMs / 60000))
  if (minutes < 1) return 'proprio ora'
  if (minutes === 1) return '1 min fa'
  if (minutes < 60) return `${minutes} min fa`
  const hours = Math.round(minutes / 60)
  return hours === 1 ? '1 ora fa' : `${hours} ore fa`
}

export function formatClockTime(iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })
}
